import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { feedbackTypeQuestion } from "../constants/questionTypes";

const FeedbackQuestion = ({ ruleFeedback, saveUpdatedAnswers, currentQuestionDet }) => {
  const [feedbackText, setFeedbackText] = useState("");
  const textareaRef = useRef();

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "inherit";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight - 16}px`;
    }
  }, []);

  useEffect(() => {
    const initial = currentQuestionDet?.response?.feedback ?? "";
    setFeedbackText(initial);
    if (textareaRef.current) {
      textareaRef.current.style.height = "inherit";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight - 16}px`;
    }
  }, [currentQuestionDet]);

  const handleInput = (e) => {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight - 16}px`;
  };

  const handleChange = (event) => {
    setFeedbackText(event.target.value);
    // Preserve all metadata from ruleFeedback including factor, factorTitle, etc.
    saveUpdatedAnswers(
      currentQuestionDet.id, 
      { 
        ...ruleFeedback,  // Include all metadata (factor, factorTitle, id, etc.)
        feedback: event.target.value, 
        question_text: ruleFeedback?.question
        
      }, 
      feedbackTypeQuestion
    );
  };

  const question = ruleFeedback?.type === "min"
          ? "We noticed you scored the following statement amongst lowest overall: " + ruleFeedback?.question
          : "You scored the following statement amongst the highest overall: " + ruleFeedback?.question

  return (
    <FeedbackContainer>
      <Title>Follow up</Title>
      <Description>
        {ruleFeedback?.type === "min"
          ? "We noticed you scored the following statement amongst lowest overall:"
          : "You scored the following statement amongst the highest overall:"}
      </Description>
      <QuestionText>{ruleFeedback?.question}</QuestionText>
      <Description>
        {ruleFeedback?.type === "min" ? (
          <span>
            You scored a <Highlight>{ruleFeedback?.response}/10</Highlight>. Can you provide specific examples of how this factor has impacted you or your colleagues?
          </span>
        ) : (
          "We'd love to know more! Please provide an example of why."
        )}
      </Description>
      <StyledTextarea
        id={`txt_${currentQuestionDet?.id}`}
        value={feedbackText}
        onChange={handleChange}
        placeholder="Type your answer here"
        ref={textareaRef}
        onInput={handleInput}
      />
    </FeedbackContainer>
  );
};

export default FeedbackQuestion;

/* styled components unchanged */
const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 600px;
  font-family: "Raleway", sans-serif;
`;
const QuestionText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  border-left: 2px solid #d5e2f9;
  margin-left: 24px;
  padding-left: 16px;
  margin-bottom: 24px;
`;
const StyledTextarea = styled.textarea`
  display: block;
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #2a3039;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  resize: none;
  font-family: "Raleway", sans-serif;
  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #2d70e2;
    outline: 0;
  }
`;
const Title = styled.div`
  color: #2d70e2;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 40px;
  display: flex;
`;
const Description = styled.div`
  color: #2a3039;
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 24px;
`;
const Highlight = styled.span`
  color: #2d70e2;
  font-weight: bold;
`;
